import { Typography } from 'antd'

const { Title } = Typography

export default function SuggestionBox() {
  return <>
    <Title level={2}>Suggestion Box</Title>
    
  </>
}